import React from 'react';

export const useHashParams = () => {
  if (typeof window !== 'undefined') {
    const [hash, setHash] = React.useState(() => window.location.hash);

    const hashChangerHnadler = React.useCallback(() => {
      setHash(window.location.hash);
    }, []);

    React.useEffect(() => {
      window.addEventListener('hashchange', hashChangerHnadler);
      return () => {
        window.removeEventListener('hashchange', hashChangerHnadler);
      };
    }, []);

    const updateHash = React.useCallback(
      (newHash: any) => {
        if (newHash !== hash) window.location.hash = newHash;
      },
      [hash],
    );

    return [hash, updateHash] as const;
  }
  return [];
};
